import type { LabelFieldKey } from "@/types/label-template";

/**
 * What a recipe supplies for each label field.
 *
 * Deliberately all-optional strings: a preview drawn before the shelf life is
 * set should show the field with an em dash, not hide it. Which fields appear
 * is the tenant's decision (T-1001); whether this recipe has filled them in yet
 * is a different question.
 */
export interface LabelFieldValues {
  RECIPE_NAME?: string | null;
  PREP_DATE?: string | null;
  USE_BY?: string | null;
  ALLERGENS?: string | null;
  STORAGE_METHOD?: string | null;
  PREPARED_BY?: string | null;
  BATCH_ID?: string | null;
  /** What the container's colour means here, in the tenant's own words (T-1005). */
  CONTAINER_FLAG?: string | null;
}

/** The dash a label prints where a value is not known yet. */
export const NO_VALUE = "—";

export function labelFieldValue(key: LabelFieldKey, values: LabelFieldValues): string {
  const value = values[key];
  return value != null && value !== "" ? value : NO_VALUE;
}

/**
 * A batch identifier for the preview.
 *
 * Cosmetic until T-1003 prints a real one — it is here so the preview shows the
 * shape of what will be printed rather than a bare dash.
 */
export function sampleBatchId(recipeId: number | string, on: Date): string {
  const day = `${on.getFullYear()}${String(on.getMonth() + 1).padStart(2, "0")}${String(
    on.getDate(),
  ).padStart(2, "0")}`;
  return `${recipeId}-${day}-B01`;
}
